import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { LsbApi, RequestStrategyEnum, type GetInquiriesRequest, type GetInquiriesResponse, type WithSignal } from '@shared/api';

const getInquiriesEffect = createEffect(({ signal, ...request }: WithSignal<GetInquiriesRequest> = {}) => LsbApi.getInquiries(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: GetInquiriesResponse }>({ total: 0, data: [] })
  .on(getInquiriesEffect.done, (_, data) => (data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] }))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getInquiriesEffect.pending, (_, data) => data)
  .on(getInquiriesEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getInquiriesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getInquiriesEffect, () => null)
  .on(getInquiriesEffect.fail, () => 'Something went wrong while fetching Inquiries. Please try again.')
  .on(getInquiriesEffect.done, () => null)
  .reset(clearEvent);

const getInquiriesApi = ApiUtils.wrapperApi(getInquiriesEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getInquiriesApi.cancel());

export const $inquiriesStore = {
  events: {
    getInquiries: getInquiriesApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
